require('./RAModalContainer.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');

// @common
const { OKButton } = require('components/commons/OKButton/OKButton');

// @utilities
const { FormattedText } = require('core/i18n').i18n;
const {
    recordLink,
    PROC_RA_GLOBAL_POSITION_INTERACTION,
} = require('utilities/tagging');

// @constants
const {
    PROC_RA_HIRE,
    PROC_RA_GLOBAL_POSITION_PATRIMONY_EVOLUTION,
} = require('../../raConstants/index');

class RAModalContainer extends React.Component {
    constructor(props) {
        super(props);

        this.handleHireClick = this.handleHireClick.bind(this);
    }

    handleHireClick() {
        this.props.validateResidential(this.props.link);
        recordLink(
            PROC_RA_GLOBAL_POSITION_INTERACTION,
            PROC_RA_HIRE,
            PROC_RA_GLOBAL_POSITION_PATRIMONY_EVOLUTION,
        );
    }

    buildButton() {
        const { link } = this.props;

        return link ? (
            <OKButton onClick={this.handleHireClick}>
                <FormattedText value="raModalContainer-contract" />
            </OKButton>
        ) : null;
    }

    render() {
        const { className, children } = this.props;
        const currentClass = classnames(['ra-modal-container', className]);
        const button = this.buildButton();

        return (
            <div className={currentClass}>
                {children}
                <div className="ra-modal-container__footer">{button}</div>
            </div>
        );
    }
}

RAModalContainer.propTypes = {
    children: PropTypes.object,
    className: PropTypes.string,
    link: PropTypes.string,
    validateResidential: PropTypes.func.isRequired,
};

module.exports = RAModalContainer;
